module.exports = __webpack_public_path__ + "static/goog-c566f92f3bcde765ff12f2dc39c6845c.png";